import { Image as ImageIcon, Video, FileText, CheckCircle2, AlertCircle, Clock, MessageSquare, Globe } from "lucide-react";

const statusIcon = {
  pending: { icon: Clock, className: "text-muted-foreground" },
  approved: { icon: CheckCircle2, className: "text-green-600" },
  changes_requested: { icon: AlertCircle, className: "text-amber-600" },
};

const typeIcon = { image: ImageIcon, video: Video, pdf: FileText };

// Vertical list of assets in a review session — thumbnails for images,
// icon tiles for video/pdf. Shared between the staff workspace and the
// public client page.
export default function ReviewAssetRail({ assets, selectedId, onSelect, getFileUrl }) {
  return (
    <div className="flex flex-col gap-2">
      {assets.map((a) => {
        const TypeIcon = typeIcon[a.file_type] || FileText;
        const st = statusIcon[a.status] || statusIcon.pending;
        const StatusIcon = st.icon;
        const isSelected = selectedId === a.id;
        return (
          <button
            key={a.id}
            onClick={() => onSelect(a.id)}
            className={`flex items-center gap-3 p-2 rounded-lg border text-left transition-colors ${
              isSelected ? "border-primary bg-primary/5" : "border-border hover:bg-muted/40"
            }`}
          >
            <div className="relative w-14 h-14 rounded-md overflow-hidden bg-muted flex items-center justify-center shrink-0">
              {a.file_type === "image" && !a.is_360 ? (
                <img src={getFileUrl(a)} alt={a.original_name} className="w-full h-full object-cover" />
              ) : (
                <TypeIcon className="w-5 h-5 text-muted-foreground" />
              )}
              {a.is_360 && (
                <span className="absolute bottom-0.5 right-0.5 flex items-center justify-center w-4 h-4 rounded-full bg-black/70 text-white" title="360° panorama">
                  <Globe className="w-2.5 h-2.5" />
                </span>
              )}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium truncate">{a.original_name}</p>
              <div className="flex items-center gap-2 mt-1 text-xs text-muted-foreground">
                <span>v{a.version}</span>
                <span className="flex items-center gap-1"><MessageSquare className="w-3 h-3" />{a.comment_count ?? 0}</span>
                <StatusIcon className={`w-3.5 h-3.5 ${st.className}`} />
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
